var map = {
	"./rate": [
		"b377",
		"chunk-5094bcb4"
	],
	"./rate.vue": [
		"b377",
		"chunk-5094bcb4"
	],
	"./restaurant": [
		"12d6",
		"chunk-2d0aaf29"
	],
	"./restaurant.vue": [
		"12d6",
		"chunk-2d0aaf29"
	],
	"./rms": [
		"3c10",
		"chunk-eb03ffa4"
	],
	"./rms.vue": [
		"3c10",
		"chunk-eb03ffa4"
	],
	"./rmsHotelsdot": [
		"0e8e",
		"chunk-0eac6f9b"
	],
	"./rmsHotelsdot.vue": [
		"0e8e",
		"chunk-0eac6f9b"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "4206";
module.exports = webpackAsyncContext;